<div class="lokos-table-wrapper">
    <div class="lokos-table">
        @if (tableReady()) {
            <table
                mat-table
                [dataSource]="dataSource"
                matSort
                class="mat-elevation-z0"
                (matSortChange)="sortData($event)"
            >
                <!-- ═══════════════════════════════════════════════════════════════
             SUPER-GROUP HEADER ROW (row 1 of 3)
             Rendered only when at least one column has `superGroup` set.
        ════════════════════════════════════════════════════════════════ -->
                @if (hasSuperGroupHeaders()) {
                    @for (item of superGroupHeaderRow(); track item.field) {
                        <ng-container
                            [matColumnDef]="item.field"
                            [sticky]="
                                isStickyColumn && $index < stickyColumnCount
                            "
                        >
                            @if (item.sort) {
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                    [attr.colspan]="item.colspan"
                                    [attr.rowspan]="item.rowspan"
                                    class="group-header super-group-header"
                                    [class.super-group-parent-header]="
                                        item.isSuperGroup
                                    "
                                    [class.super-group-standalone-header]="
                                        !item.isSuperGroup
                                    "
                                >
                                    {{ item.label | translate }}
                                </th>
                            } @else {
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    [attr.colspan]="item.colspan"
                                    [attr.rowspan]="item.rowspan"
                                    class="group-header super-group-header"
                                    [class.super-group-parent-header]="
                                        item.isSuperGroup
                                    "
                                    [class.super-group-standalone-header]="
                                        !item.isSuperGroup
                                    "
                                >
                                    {{ item.label | translate }}
                                </th>
                            }
                        </ng-container>
                    }

                    <!-- ROW 1: super-group spanning header -->
                    <tr
                        mat-header-row
                        *matHeaderRowDef="superGroupFields(); sticky: true"
                        class="super-parent-row"
                    ></tr>
                }

                <!-- ═══════════════════════════════════════════════════════════════
             GROUP HEADER ROW (row 2 of 3  –OR–  row 1 of 2)
             Rendered when at least one column has `group` set.
        ════════════════════════════════════════════════════════════════ -->
                @if (hasGroupHeaders()) {
                    @for (item of groupHeaderRow(); track item.field) {
                        <ng-container
                            [matColumnDef]="item.field"
                            [sticky]="
                                isStickyColumn && $index < stickyColumnCount
                            "
                        >
                            @if (item.sort) {
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                    [attr.colspan]="item.colspan"
                                    [attr.rowspan]="item.rowspan"
                                    class="group-header"
                                    [class.group-parent-header]="item.isGroup"
                                    [class.group-standalone-header]="
                                        !item.isGroup
                                    "
                                >
                                    {{ item.label | translate }}
                                </th>
                            } @else {
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    [attr.colspan]="item.colspan"
                                    [attr.rowspan]="item.rowspan"
                                    class="group-header"
                                    [class.group-parent-header]="item.isGroup"
                                    [class.group-standalone-header]="
                                        !item.isGroup
                                    "
                                >
                                    {{ item.label | translate }}
                                </th>
                            }
                        </ng-container>
                    }

                    <!-- TOP HEADER ROW (group labels) -->
                    <tr
                        mat-header-row
                        *matHeaderRowDef="topHeaderFields(); sticky: true"
                        class="parent-row"
                    ></tr>
                }

                <!-- ═══════════════════════════════════════════════════════════════
             COLUMN DEFINITIONS  (data columns)
        ════════════════════════════════════════════════════════════════ -->
                @for (col of columns; track $index) {
                    <ng-container
                        matColumnDef="{{ col?.field }}"
                        [sticky]="isStickyColumn && $index < stickyColumnCount"
                    >
                        @if (col?.sort) {
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                                matTooltip="{{ col?.label | translate }}"
                            >
                                @if (col?.field === 'select') {
                                    @if (col?.label) {
                                        {{ col?.label | translate }}
                                    } @else {
                                        <mat-checkbox
                                            (click)="$event.stopPropagation()"
                                            (change)="
                                                $event ? toggleAllRows() : null
                                            "
                                            [checked]="
                                                selection.hasValue() &&
                                                isAllSelected()
                                            "
                                            [indeterminate]="
                                                selection.hasValue() &&
                                                !isAllSelected()
                                            "
                                            [aria-label]="checkboxLabel()"
                                        ></mat-checkbox>
                                    }
                                } @else {
                                    {{ col?.label | translate }}
                                }
                            </th>
                        } @else {
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                matTooltip="{{ col?.label | translate }}"
                            >
                                @if (col?.field === 'select') {
                                    @if (col?.label) {
                                        {{ col?.label | translate }}
                                    } @else {
                                        <mat-checkbox
                                            (click)="$event.stopPropagation()"
                                            (change)="
                                                $event ? toggleAllRows() : null
                                            "
                                            [checked]="
                                                selection.hasValue() &&
                                                isAllSelected()
                                            "
                                            [indeterminate]="
                                                selection.hasValue() &&
                                                !isAllSelected()
                                            "
                                            [aria-label]="checkboxLabel()"
                                        ></mat-checkbox>
                                    }
                                } @else {
                                    {{ col?.label | translate }}
                                }
                            </th>
                        }

                        <td mat-cell *matCellDef="let row; let i = index">
                            @if (col?.field === 'select') {
                                <mat-checkbox
                                    (click)="$event.stopPropagation()"
                                    (change)="
                                        $event ? toggleRowsSelection(row) : null
                                    "
                                    [checked]="selection.isSelected(row)"
                                    [aria-label]="checkboxLabel(row)"
                                    [disabled]="disableCheckbox(row)"
                                >
                                </mat-checkbox>
                            }

                            @if (col?.field !== 'action') {
                                @if (col?.custom) {
                                    <lokos-custom-column
                                        [rowData]="row"
                                        [columnDetails]="col"
                                        [entity]="entity"
                                        (componentEvent)="
                                            customColumnEvent.emit($event)
                                        "
                                    ></lokos-custom-column>
                                } @else if (col?.field === 'index') {
                                    {{ activePageIndex * pageSize + (i + 1) }}
                                } @else if (
                                    col?.field === 'amount' &&
                                    col?.isIndianCurrency
                                ) {
                                    {{ row[col?.field] ? '₹' : '' }}
                                    {{ row[col?.field] | number: '1.2-2' }}
                                } @else if (
                                    col?.isIndianCurrency &&
                                    row[col?.field] === 0
                                ) {
                                    {{ row[col?.field] ? '₹' : '₹' }}
                                    {{ row[col?.field] | number: '1.2-2' }}
                                } @else if (col?.isIndianCurrency) {
                                    {{ row[col?.field] ? '₹' : '₹ 0.0' }}
                                    {{ row[col?.field] | number: '1.2-2' }}
                                } @else if (col?.isNumberFormat) {
                                    {{ row[col?.field] | numberFormat }}
                                } @else if (col?.isLakhAmount) {
                                    {{ row[col?.field] | lakhAmount }}
                                } @else {
                                    <div matTooltip="{{ row[col?.field] }} ">
                                        {{ row[col?.field] }}
                                    </div>
                                }
                            }

                            @if (col?.field === 'action') {
                                <lokos-custom-action
                                    [rowData]="row"
                                    [columnDetails]="col"
                                    [entity]="entity"
                                    (actioncComponentEvent)="
                                        customActionEvent.emit($event)
                                    "
                                ></lokos-custom-action>
                            }
                        </td>

                        <td mat-footer-cell *matFooterCellDef>
                            @if (showTotalRow && tableRecord.length) {
                                @if (col?.field === 'index') {
                                    <strong></strong>
                                }

                                <!-- Total label in first non-index column -->
                                @else if (
                                    $index === 0 ||
                                    columns[$index - 1]?.field === 'index'
                                ) {
                                    <strong>{{
                                        totalLabel | translate
                                    }}</strong>
                                } @else if (isTotalRowCustom) {
                                    <lokos-custom-column
                                        [rowData]="totalRowData"
                                        [columnDetails]="col"
                                        [entity]="entity"
                                    />
                                }

                                <!-- Your existing logic -->
                                @else if (
                                    totalRowData[col?.field] !== undefined &&
                                    totalRowData[col?.field] !== null &&
                                    col?.field === 'todaysAttendance'
                                ) {
                                    <strong>{{
                                        `${totalRowData[col?.field]}/${tableRecord.length}`
                                    }}</strong>
                                } @else if (
                                    totalRowData[col?.field] !== undefined &&
                                    totalRowData[col?.field] !== null &&
                                    col?.isIndianCurrency
                                ) {
                                    <strong>{{
                                        totalRowData[col?.field]
                                            | indianCurrency: true
                                    }}</strong>
                                } @else if (col?.isNumberFormat) {
                                    <strong>{{
                                        totalRowData[col?.field] | numberFormat
                                    }}</strong>
                                } @else if (col?.isLakhAmount) {
                                    <strong>{{
                                        totalRowData[col?.field] | lakhAmount
                                    }}</strong>
                                } @else if (
                                    totalRowData[col?.field] !== undefined &&
                                    totalRowData[col?.field] !== null &&
                                    col?.isPercentage
                                ) {
                                    <strong>{{
                                        totalRowData[col?.field]
                                            | number: '1.2-2'
                                    }}</strong>
                                } @else if (
                                    totalRowData[col?.field] !== undefined &&
                                    totalRowData[col?.field] !== null
                                ) {
                                    <strong>{{
                                        totalRowData[col?.field]
                                    }}</strong>
                                }
                            }
                        </td>
                    </ng-container>
                }

                <!-- ═══════════════════════════════════════════════════════════════
             TOP TOTAL ROW COLUMN DEFS (rendered as a header-area row so the
             total appears as the FIRST body row). Same logic as the footer
             total cell. Gated by showTotalRowOnTop.
        ════════════════════════════════════════════════════════════════ -->
                @if (showTotalRowOnTop) {
                    @for (col of columns; track $index) {
                        <ng-container
                            matColumnDef="total_{{ col?.field }}"
                            [sticky]="
                                isStickyColumn && $index < stickyColumnCount
                            "
                        >
                            <th mat-header-cell *matHeaderCellDef>
                                @if (showTotalRow && tableRecord.length) {
                                    @if (col?.field === 'index') {
                                        <strong></strong>
                                    }

                                    <!-- Total label in first non-index column -->
                                    @else if (
                                        $index === 0 ||
                                        columns[$index - 1]?.field === 'index'
                                    ) {
                                        <strong>{{
                                            totalLabel | translate
                                        }}</strong>
                                    } @else if (
                                        totalRowData[col?.field] !==
                                            undefined &&
                                        totalRowData[col?.field] !== null &&
                                        col?.field === 'todaysAttendance'
                                    ) {
                                        <strong>{{
                                            `${totalRowData[col?.field]}/${tableRecord.length}`
                                        }}</strong>
                                    } @else if (
                                        totalRowData[col?.field] !==
                                            undefined &&
                                        totalRowData[col?.field] !== null &&
                                        col?.isIndianCurrency
                                    ) {
                                        <strong>{{
                                            totalRowData[col?.field]
                                                | indianCurrency: true
                                        }}</strong>
                                    } @else if (col?.isNumberFormat) {
                                        <strong>{{
                                            totalRowData[col?.field]
                                                | numberFormat
                                        }}</strong>
                                    } @else if (col?.isLakhAmount) {
                                        <strong>{{
                                            totalRowData[col?.field]
                                                | lakhAmount
                                        }}</strong>
                                    } @else if (
                                        totalRowData[col?.field] !==
                                            undefined &&
                                        totalRowData[col?.field] !== null
                                    ) {
                                        <strong>{{
                                            totalRowData[col?.field]
                                        }}</strong>
                                    }
                                }
                            </th>
                        </ng-container>
                    }
                }

                <!-- ═══════════════════════════════════════════════════════════════
             SUB-HEADER ROW (individual column labels — always last header row)
        ════════════════════════════════════════════════════════════════ -->
                @if (hasGroupHeaders()) {
                    <tr
                        mat-header-row
                        *matHeaderRowDef="subHeaderFields(); sticky: true"
                        class="sub-header-row"
                    ></tr>
                } @else {
                    <tr
                        mat-header-row
                        *matHeaderRowDef="displayColumns; sticky: true"
                    ></tr>
                }

                <!-- Top total row (renders directly above the data rows) -->
                @if (showTotalRowOnTop) {
                    <tr
                        mat-header-row
                        *matHeaderRowDef="totalDisplayColumns"
                        class="total-row-top"
                        [style.visibility]="
                            showTotalRow && tableRecord.length
                                ? 'visible'
                                : 'collapse'
                        "
                    ></tr>
                }

                <!-- Data rows -->
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayColumns"
                    [ngClass]="row.highlightRow ? 'highlight-row' : ''"
                ></tr>
                <!-- Footer / totals row -->
                <tr
                    mat-footer-row
                    *matFooterRowDef="displayColumns; sticky: isTotalRowSticky"
                    class="total-row"
                    [style.visibility]="
                        showTotalRow && tableRecord.length && !showTotalRowOnTop
                            ? 'visible'
                            : 'collapse'
                    "
                ></tr>
            </table>
        }
    </div>
    @if (!tableRecord.length) {
        <div class="no-data-content">
            <img src="../../../../../assets/images/noDataFound.svg" alt="" />
            <h1>{{ noDataFoundText | translate }}</h1>
        </div>
    }
    @if (hasFooterStrip) {
        <div class="lokos-table-footer">
            <span class="footer-section footer-left">{{ footerLeft }}</span>
            <span class="footer-section footer-middle">{{ footerMiddle }}</span>
            <span class="footer-section footer-right">{{ footerRight }}</span>
        </div>
    }
</div>
